import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut, LayoutDashboard, UserCircle } from "lucide-react";
import { Logo } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/", label: "Beranda", id: "home" },
  { to: "/kategori", label: "Kategori Ujian", id: "categories" },
  { to: "/tryout", label: "Daftar Tryout", id: "tryouts" },
];

export const Navbar = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const dash = user?.role === "admin" ? "/admin" : "/dashboard";
  const doLogout = () => {
    logout();
    setOpen(false);
    nav("/");
  };
  const linkCls = ({ isActive }) => `text-sm font-semibold transition-colors ${isActive ? "text-amber-600" : "text-slate-700 hover:text-[#0A192F]"}`;

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end className={linkCls} data-testid={`nav-${l.id}`}>{l.label}</NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-2 md:flex">
          {user ? (
            <>
              <Button variant="ghost" onClick={() => nav(dash)} data-testid="nav-dashboard-btn"><LayoutDashboard className="mr-2 h-4 w-4" />Dashboard</Button>
              <Button variant="ghost" onClick={() => nav("/profil")} data-testid="nav-profile-btn"><UserCircle className="mr-2 h-4 w-4" />{user.name.split(" ")[0]}</Button>
              <Button variant="outline" onClick={doLogout} data-testid="nav-logout-btn"><LogOut className="h-4 w-4" /></Button>
            </>
          ) : (
            <>
              <Button variant="ghost" onClick={() => nav("/login")} data-testid="nav-login-btn">Masuk</Button>
              <button onClick={() => nav("/daftar")} className="btn-gold rounded-lg px-5 py-2 text-sm" data-testid="nav-register-btn">Daftar Gratis</button>
            </>
          )}
        </div>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="space-y-1 border-t bg-white px-4 py-3 md:hidden" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block rounded-md px-3 py-2 font-semibold text-slate-700 hover:bg-slate-50">{l.label}</Link>
          ))}
          {user ? (
            <>
              <Link to={dash} onClick={() => setOpen(false)} className="block rounded-md px-3 py-2 font-semibold text-slate-700" data-testid="nav-mobile-dashboard">Dashboard</Link>
              <Link to="/profil" onClick={() => setOpen(false)} className="block rounded-md px-3 py-2 font-semibold text-slate-700">Profil</Link>
              <button onClick={doLogout} className="block w-full rounded-md px-3 py-2 text-left font-semibold text-red-600" data-testid="nav-mobile-logout">Keluar</button>
            </>
          ) : (
            <div className="flex gap-2 pt-2">
              <Button variant="outline" className="flex-1" onClick={() => { setOpen(false); nav("/login"); }} data-testid="nav-mobile-login">Masuk</Button>
              <button className="btn-gold flex-1 rounded-lg py-2 text-sm" onClick={() => { setOpen(false); nav("/daftar"); }} data-testid="nav-mobile-register">Daftar</button>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export const Footer = ({ settings }) => (
  <footer className="navy-hero mt-20 text-slate-300">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3">
      <div className="space-y-3">
        <Logo light />
        <p className="text-sm italic text-amber-300/90">{settings?.tagline || "Langkah Cerdas, Raih Prestasi."}</p>
        <p className="max-w-xs text-sm text-slate-400">{settings?.about}</p>
      </div>
      <div>
        <h4 className="mb-3 text-sm font-bold uppercase tracking-widest text-white">Navigasi</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/kategori" className="hover:text-amber-300">Kategori Ujian</Link></li>
          <li><Link to="/tryout" className="hover:text-amber-300">Daftar Tryout</Link></li>
          <li><Link to="/dashboard" className="hover:text-amber-300">Dashboard Peserta</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="mb-3 text-sm font-bold uppercase tracking-widest text-white">Kontak</h4>
        <ul className="space-y-2 text-sm text-slate-400" data-testid="footer-contact">
          {settings?.contact_email && <li>{settings.contact_email}</li>}
          {settings?.contact_phone && <li>{settings.contact_phone}</li>}
          {settings?.address && <li>{settings.address}</li>}
          {!settings?.contact_email && !settings?.contact_phone && <li>Informasi kontak diatur admin.</li>}
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">© {new Date().getFullYear()} ADIKARA ACADEMY. Hak cipta dilindungi.</div>
  </footer>
);
